<svg
	width="16"
	height="16"
	viewBox="0 0 16 16"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<circle cx="2.5" cy="8" r="1.5" fill="currentColor" />
	<circle cx="8" cy="8" r="1.5" fill="currentColor" />
	<circle cx="13.5" cy="8" r="1.5" fill="currentColor" />
</svg>
